import {intersectSounds} from './intersectSounds.js';

export async function getSoundsWithFields(fields, getSoundsWithField) {
    let promises:Promise<void>[]  = [];

    for (let i in fields) {
        // field could mean a tag
        let field = fields[i];
        promises.push(getSoundsWithField(field));
    }
    
    let fieldToSounds = await Promise.all(promises);
    
    let sounds = new Set(fieldToSounds[0]);
    
    // basically want to intersect all of the lists together
    // e.g. we are looking for all sounds with ['808', 'hi-hat', 'pierre bourne']
    // this is an AND operation, and because of this we intersect
    for (let i in fieldToSounds) {
        if (i == 0) {
            continue;
        }
        let soundsWithField = new Set(fieldToSounds[i]);
        sounds = intersectSounds(sounds, soundsWithField);
    }
    
    return Array.from(sounds);
}
